import request from "./reqest";
import store from "../store";

import {language} from "../language/get";
import { Notification, MessageBox } from 'element-ui';
var initParam;
var initOnmessage;
//是否在直播间
var isRoom = false;
var resetConnectNum = 0;
var resetConnectId = '';
function resetConnect(){
  if(resetConnectId == ''){

    console.log('-----------resetConnect------------')
    resetConnectId = setInterval(function(){
      if(resetConnectNum >= 3){
        clearInterval(resetConnectId)
        MessageBox({
          title: language().hint,
          message: language().networkDisconnect,
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
          type: 'warning'
        }).then(() => {
          //确认
          if (location.pathname == "/livestudio.html") {
            window.history.go(-1);
          }
        }).catch(() => {
          //取消         
        });
          
        
        return;
      }
      resetConnectNum++;
      init(initParam, initOnmessage)
      console.log('-----------resetConnect------------',resetConnectNum)
      
    }, 5000);
  }
}
function getWebSocket(callback, heartBeatParam) {
  let data = {};
  const socket = new WebSocket("wss://exhxcx.shippingchina.com:433");
  socket.onopen = (e) => {
    console.log("连接成功");
    //心跳包 30秒一次
  };
  /**
   * 方法将需要通过 WebSocket
   * 链接传输至服务器的数据排入队列，
   * 并根据所需要传输的data bytes的大小来增加
   * bufferedAmount的值
   */
  socket.onmessage = (e) => {
    //将字符串转换成JSON对象
    try {
      console.log("======================>",e)
      data = JSON.parse(e.data);
      callback(data);
    } catch (e) {
      console.log(e)
    }
  }
  // 当客户端收到服务端发送的关闭连接请求时，触发onclose事件
  socket.onclose = (e) => {
    resetConnect();
  }


  //如果出现连接、处理、接收、发送数据失败的时候触发onerror事件
  socket.onerror = (e) => {
    resetConnect();
  }
  return socket;
}
function send(socket, data) {
  data = data || {
    type: 2,
    data: 'heart beat'
  }
  socket.send(JSON.stringify(data));
}

function init(param, onmessage) {
  initParam = param
  initOnmessage = onmessage
  if (store.getters.token) {
    var socket = getWebSocket((data) => {
      console.log(data)
      resetConnectNum = 0;
      clearInterval(resetConnectId);
      resetConnectId = '';
      var type = data.data.type;
      // type=1代表成功
      if (type == 1) {
        var requestData = {
          client_id: data.data.client_id,
          token: param.token
        }

        if (param.roomId) {
          requestData.roomid = param.roomId;
        }
        // if (param.heartBeatParam.roomid) {
        //   isRoom = true;
        // }else {
        //   isRoom = false
        // }
        request.send('/Gateway/Bind_user', JSON.stringify(requestData)).then((res) => {
          if (res.type == 1) {
            if (param.goRoomParam) {
              request.send('/Gateway/Go_Room', JSON.stringify(param.goRoomParam)).then((res) => {
                if (res.type == 1) {
                  send(socket, param.heartBeatParam);
                  setInterval(() => {
                    send(socket, param.heartBeatParam);
                  }, 30000);
                } else {
                  //alert('进入失败,请重试');
                  history.go(-1);
                }
              });
            } else {
              send(socket, param.heartBeatParam);
              setInterval(() => {
                send(socket, param.heartBeatParam);
              }, 30000);
            }
          }
        });

      }
      onmessage(data);
    }, param.heartBeatParam);
    return socket;
  }
}
export {
  getWebSocket,
  init
};
